// TODO: delete this file when the flag getGroupAndUserNamesEnabled is deleted
// since all uses of this call will be redirected to getGroupAndUserNames

import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IUserName } from '../types/IUser';
import { Request } from './Request';

export interface IGetUserNamesResult extends IGetItemsResult {
  users: IUserName[];
}

export class GetUserNamesRequest extends Request<IGetItemsParams, IGetUserNamesResult> {
  constructor(params: IGetItemsParams) {
    super('getUserNames', params);
  }
}
